import ReactGA from 'react-ga';

const trackingId = "G-8EYDLC5LP3";
ReactGA.initialize(trackingId);

export const trackPageView = (page) => {
  ReactGA.set({ page });
  ReactGA.pageview(page);
};
